import qs from 'qs'

import MarketplaceLayoutIndexPage from 'src/components/pages/marketplace/MarketplaceLayoutIndexPage'

const MarketplacePluginsPage = ({ plugins, filters, pagination }) => {
  return (
    <MarketplaceLayoutIndexPage
      npmPackages={plugins}
      npmPackageType="plugin"
      filters={filters}
      pagination={pagination}
    />
  )
}

export async function getServerSideProps({ query }) {
  if (query?.collections && !Array.isArray(query?.collections)) {
    query.collections = Array(query.collections)
  }

  if (query?.categories && !Array.isArray(query?.categories)) {
    query.categories = Array(query.categories)
  }

  if (query?.version && !Array.isArray(query?.version)) {
    query.version = Array(query.version)
  }

  const queryString = qs.stringify(
    {
      ...query,
      pagination: {
        page: query.page || 1,
        pageSize: 24,
      },
    },
    { encode: false }
  )

  const result = await fetch(
    `${process.env.NEXT_PUBLIC_MARKETPLACE_API_URL}/plugins${
      query ? `?${queryString}` : ''
    }`
  )
  const { data, meta } = await result.json()
  const { pagination, ...filters } = meta

  return {
    props: {
      plugins: data,
      filters: filters,
      pagination: pagination,
    },
  }
}

export default MarketplacePluginsPage
